/* Ginza brands 1.0.0 · client-side search over the server-rendered A–Z list. */
if (!customElements.get('ginza-brands')) {
  const normalize = (value) =>
    value
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[_\s]+/g, ' ')
      .trim();

  class GinzaBrands extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search]');
      this.clearBtn = this.querySelector('[data-clear]');
      this.countEl = this.querySelector('[data-count]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.logos = this.querySelector('.ginza-brands__logos');
      this.groups = [...this.querySelectorAll('[data-group]')].map((group) => ({
        el: group,
        letter: group.dataset.group,
        items: [...group.querySelectorAll('.ginza-brands__name')].map((li) => ({
          el: li,
          key: normalize(li.textContent),
        })),
      }));
      this.letterLinks = [...this.querySelectorAll('a[data-letter]')];
      if (!this.input) return;

      this.onInput = () => {
        this.toggleClear();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.filter(), 100);
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          this.clear();
        }
      };
      this.onClear = () => {
        this.clear();
        this.input.focus();
      };
      this.onBlockSelect = (event) => {
        if (this.logos && this.logos.contains(event.target)) this.logos.classList.add('is-paused');
      };
      this.onBlockDeselect = () => this.logos && this.logos.classList.remove('is-paused');

      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('keydown', this.onKeydown);
      this.clearBtn.addEventListener('click', this.onClear);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      /* Restore a value the browser kept after back/forward navigation. */
      if (this.input.value) {
        this.toggleClear();
        this.filter();
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (!this.input) return;
      this.input.removeEventListener('input', this.onInput);
      this.input.removeEventListener('keydown', this.onKeydown);
      this.clearBtn.removeEventListener('click', this.onClear);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    toggleClear() {
      this.clearBtn.hidden = this.input.value.length === 0;
    }

    clear() {
      this.input.value = '';
      this.toggleClear();
      this.filter();
    }

    filter() {
      const query = normalize(this.input.value);
      let visible = 0;
      const lettersWithResults = new Set();

      this.groups.forEach((group) => {
        let groupVisible = 0;
        group.items.forEach((item) => {
          const match = !query || item.key.includes(query);
          item.el.hidden = !match;
          if (match) groupVisible += 1;
        });
        group.el.hidden = groupVisible === 0;
        if (groupVisible) lettersWithResults.add(group.letter);
        visible += groupVisible;
      });

      this.letterLinks.forEach((link) => {
        const active = lettersWithResults.has(link.dataset.letter);
        link.classList.toggle('is-empty', !active);
        if (active) {
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '-1');
        }
      });

      this.emptyEl.hidden = visible > 0;
      const template = visible === 1 ? this.dataset.countTextOne : this.dataset.countText;
      this.countEl.textContent = (template || '[count]').replace('[count]', visible);
    }
  }

  customElements.define('ginza-brands', GinzaBrands);
}
